import { render, staticRenderFns } from "./SubmitOopJustificationDialog.vue?vue&type=template&id=efe1c0b4&scoped=true"
import script from "./SubmitOopJustificationDialog.vue?vue&type=script&lang=js"
export * from "./SubmitOopJustificationDialog.vue?vue&type=script&lang=js"
import style0 from "./SubmitOopJustificationDialog.vue?vue&type=style&index=0&id=efe1c0b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe1c0b4",
  null
  
)

export default component.exports